import { useNavigate } from "react-router-dom";

const games = [
  // { name: "Cricket", img: "/icons/cricket.png", url: "#" },
  { name: "Aviator", img: "/icons/plane.png", url: "/aviator" },
  { name: "LUDO", img: "/assets/roll.png", url: "/ludo" },
  { name: "CHESS", img: "/assets/chess.png", url: "/chess" },
  { name: "HEADTAIL", img: "/assets/headtail.png", url: "/headtail" },
  { name: "TEENPATTI", img: "/assets/teen-patti.png", url: "/teenpatti" },
  { name: "Matka", img: "/icons/matka.png", url: "/matkaList" },
  { name: "Lucky7", img: "/icons/lucky7.png", url: "/lucky7" },
  { name: "12 TILES", img: "/icons/chidiya.png", url: "/titli" },
  { name: "Mines Game", img: "/icons/bomb2.png", url: "/mineGame" },
  { name: "Win Go", img: "/icons/wingo2.png", url: "/colorGame" },
  { name: "Spin Wheel", img: "/icons/spin.png", url: "/spinWheel" },
  { name: "K3", img: "/icons/spin.png", url: "/k3" },
  { name: "5D", img: "/icons/spin.png", url: "/5d" },
];

export default function UserSidebar({ open, close }) {
  const navigate = useNavigate();
  return (
    <>
      <div className={`user-sidebar ${open ? "open" : ""}`}>
        {/* CLOSE BUTTON (mobile only) */}
        <div className="sidebar-header d-flex justify-content-between align-items-center p-2 d-lg-none">
          <div className="d-flex align-items-center gap-2">
            <img src="/logo.png" height="36" alt="logo" className="rounded-circle"/>
          </div>

          <button className="btn btn-light btn-sm d-lg-none" onClick={close}>
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        {/* MENU ITEMS */}
        <div className="p-2">
          {games.map((g, i) => (
            <div key={i} className="game-menu d-flex align-items-center gap-2" onClick={() => navigate(g.url)}>
              <img src={g.img} width="40" height="40"/>
              <span>{g.name}</span>
            </div>
          ))}
        </div>
      </div>

      {/* overlay */}
      {open && window.innerWidth < 992 && (
        <div className="user-overlay" onClick={close}></div>
      )}
    </>
  );
}
